/**
 * Convert the given object into an array of (Anguler template accessible) keypair objects,
 * while retaining the type information.
 *
 * @param object
 * @returns
 */
export function pairs<K extends string, V>(object: Record<K, V>): ({ key: K, value: V })[] {
    return <any> Object.entries(object).map(([key, value]) => ({ key, value }));
}